<template>
    <div class="wrapper blog-posts">
        <div class="page-header page-header-small signup-page section-image">
            <parallax class="page-header-image" style="background-image: url('img/homepage/loginHero.jpg') ;">
            </parallax>
            <div class="content-center">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center">
                    <a :href="blogs.ButtonLink" target="_blank">
                        <h2 class="title">
                            {{blogs.ButtonName}}
                        </h2>
                    </a>
                        
                        <!-- <h5>{{blogs.tag}} | {{blogs.date}}</h5> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="main">
            <div class="container">
                <div class="section">
                    <!-- <h3 class="title text-center">You may also be interested in</h3> -->
                    <br/>

                <div class="row">
                    <div class="col-md-8">
                        <div v-html="blogs.contentDetail" />
                        <!-- {{blogs.contentDetail}} -->

                    </div>
                   <!-- SIDEBAR BEGINS -->
                    <div class="col-md-4">
                       <sidebar></sidebar>
                    </div>
                    <!-- SIDEBAR ENDS -->
                </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import { Card, Button, FormGroupInput, Pagination } from '@/components';
  import { Carousel, CarouselItem, Table, TableColumn } from 'element-ui'
  import db from '../../components/Firebase/firebaseInit'
  import Sidebar from '@/pages/bet/sidebar';
  import firebase from 'firebase';

  export default {
    name: 'blog-posts',
    bodyClass: 'blog-posts',
    components: {
      Sidebar,
      Card,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Pagination.name]: Pagination,
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput
    },
    data() {
      return {
        year: new Date().getFullYear(),
        item_id: null,
        blogs: {
            ButtonLink: null,
            contentDetail: null,
            ButtonName: null
        },
      }
    },
    created(){
    db.collection('australiaReviewsMain')
    .where(firebase.firestore.FieldPath.documentId(), '==', this.$route.params.item_id)
    .get()
    .then(querySnapshot => {
      querySnapshot.forEach(doc => {
        this.blogs.contentDetail = doc.data().contentDetail;
        this.blogs.ButtonLink = doc.data().buttonLink;
        this.blogs.ButtonName = doc.data().button;
      })
    })

    }
  }
</script>
<style>
</style>
